module.exports = __webpack_public_path__ + "static/media/24UHCHR6.bac7cc9b.jpg";